import { pageForPath } from './navbar/navItems';

/**
 * How often this admin opens each page, kept in the browser so the dashboard
 * can list their most used ones. Keyed per uid, so two people sharing a
 * browser get their own list.
 */
const storageKey = (uid) => `backoffice.pageUsage.${uid || 'anon'}`;

const read = (uid) => {
    try {
        const parsed = JSON.parse(window.localStorage.getItem(storageKey(uid)));
        return parsed && typeof parsed === 'object' ? parsed : {};
    } catch {
        return {};
    }
};

export const recordPageVisit = (uid, pathname) => {
    const page = pageForPath(pathname);
    if (!page || page.key === '/dashboard') return;
    try {
        const counts = read(uid);
        counts[page.key] = (counts[page.key] || 0) + 1;
        window.localStorage.setItem(storageKey(uid), JSON.stringify(counts));
    } catch {
        /* storage blocked or full */
    }
};

/** The `limit` most opened pages, most opened first; only pages that still exist in the menu. */
export const mostUsedPages = (uid, limit = 5) =>
    Object.entries(read(uid))
        .map(([key, count]) => ({ page: pageForPath(key), count }))
        .filter(({ page, count }) => page && count > 0)
        .sort((a, b) => b.count - a.count)
        .slice(0, limit);
